export enum PaymentMethodCode {
    BANCONTACT = "BANCONTACT",
    CREDITCARD = "CREDITCARD",
    GIFTCARD = "GIFTCARD",
    COUPON = "COUPON",
    TERMINAL = "TERMINAL",
    VOUCHER = "VOUCHER",
    KLARNA = "KLARNA"
}
